import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../../fields/Button'
import FlagSelector from '../../fields/FlagSelector'
import logo from '../../../assets/logo.png'
import './PublicNavbar.css'

export default function PublicNavbar() {
  const [scrolled, setScrolled] = useState(false)
  const navigate = useNavigate()
  const { t } = useTranslation('landing')

  useEffect(() => {
    const handleScroll = () => {
      const threshold = window.innerHeight * 0.7
      setScrolled(window.scrollY > threshold)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <nav
      className={`public-navbar${scrolled ? ' public-navbar--visible' : ''}`}
    >
      <div className="public-navbar__inner">
        <button
          className="public-navbar__brand"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Rustaro"
        >
          <img src={logo} alt="Rustaro" className="public-navbar__logo" />
        </button>
        <div className="public-navbar__actions">
          <FlagSelector />
          <Button
            variant="tertiary"
            size="small"
            onClick={() => navigate('/contact')}
          >
            {t('hero.ctaContact')}
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={() => navigate('/login')}
          >
            {t('hero.ctaLogin')}
          </Button>
        </div>
      </div>
    </nav>
  )
}
